<template>
  <div class="handover_examine">
    <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.push('/')">返回</el-button>
    <el-divider content-position="left">企业火小程序配置管理</el-divider>
    <div>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-button round @click="$router.push('/qyh_head_bg')">头部背景图片管理</el-button>
          <!-- <el-button type="primary" round>主要按钮</el-button>
          <el-button type="success" round>成功按钮</el-button>
          <el-button type="info" round>信息按钮</el-button>
          <el-button type="warning" round>警告按钮</el-button>
          <el-button type="danger" round>危险按钮</el-button> -->
        </el-col>
      </el-row>
    </div>

    <div style="display:none">
      <div style="display:flex;">
        <div>
          <!-- <el-input ref="input" v-model="searchArr.phone_order" placeholder="名称/分类名称" size="mini"
          clearable :loading="searchLoading" prefix-icon="el-icon-search">
        </el-input> -->
          <el-select v-model="searchArr.phone_order" filterable remote reserve-keyword placeholder="名称/分类名称" size="mini"
            clearable :remote-method="searchRemoteCfcategory" :loading="searchLoading" @change="handleSearchCfcategory"
            prefix-icon="el-icon-search">
            <el-option v-for="searchCompany in searchCategories" :key="searchCompany.id" :label="searchCompany.name"
              :value="searchCompany.id">
            </el-option>
          </el-select>
        </div>
        <!-- <div style="margin-left:0.2rem">
        <el-popover placement="bottom-start" v-model="visible" width="500">
          <el-form :model="searchArr" ref="searchForm" label-width="100px"
            style="margin-left:-0.3rem">
            <el-form-item label="所属业务" prop="salesman_id">
              <el-select v-model="searchArr.salesman_id" placeholder="请选择财税负责人筛选" filterable
                clearable size="mini">
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username"
                  :value="user.id"></el-option>
              </el-select>
            </el-form-item> -->
        <!-- <el-form-item label="支付人/手机号" prop="payuser_id">
              <el-input v-model="searchArr.payuser_id" size="mini"
                placeholder="支付人 / 手机号"></el-input>
            </el-form-item>
            <el-form-item label="支付时间" prop="send_pay_date">
              <el-date-picker size="mini" v-model="searchArr.send_pay_date" type="datetimerange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="创建时间" prop="created_at">
              <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="text-align: right;margin-right:0.3rem">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </div> -->
        <div style="text-align: right; flex: 1">
          <el-button type="primary" size="mini" @click="categoryIn">录入</el-button>
        </div>
      </div>
      <el-drawer :visible.sync="categoryIndrawer" :direction="direction" :before-close="handleClose" size="40%">
        <template slot="title">
          <span style="color:#409eff;font-size:large;">录入</span>
        </template>
        <div style="padding: 0.2em 1.4em; margin-top: -17px">
          <el-form :model="categoryForm" :rules="rules" ref="categoryForm" label-width="80px">
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>分类信息</span>
              </div>
              <div style="white-space:nowrap;">
                <el-form-item label-width="75px" label="分类" prop="name" style="display:inline-block;width:50%">
                  <el-select v-model="categoryForm.name" placeholder="请选择" style="width: 100%" clearable filterable
                    @click.native="getItem_cate" size="mini">
                    <el-option v-for="item in itemCate_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label-width="75px" label="" prop="" style="display:inline-block;width:50%">
                  <el-popover placement="left-start" width="500" trigger="click">
                    <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="80px">
                      <el-form-item label="分类名称" prop="addressee">
                        <el-input v-model.trim="addAddressForm.addressee" size="mini" placeholder="请填写分类名称"></el-input>
                      </el-form-item>
                    </el-form>
                    <div style="
                      margin-top: 0.15rem;
                      text-align: right;
                      padding-right: 0.16rem;
                    ">
                      <el-button type="primary" size="mini" @click="saveChange('addAddressForm')">保存</el-button>
                    </div>
                    <el-button type="primary" size="mini" slot="reference" style="cursor: pointer">新增分类 <i
                        class="el-icon-plus"></i></el-button>
                  </el-popover>
                </el-form-item>
                <!-- <el-form-item label-width="75px" label="手机号" prop="phone"
                style="display:inline-block;width:50%">
                <el-input v-model.trim="categoryForm.phone" size="mini" clearable></el-input>
              </el-form-item> -->
                <!-- <el-form-item label-width="75px" label="飞书链接" prop="feishuurl">
                <el-input v-model.trim="categoryForm.feishuurl" size="mini" clearable></el-input>
              </el-form-item>
              <upfile name="上传简历" :many="1"
                action="https://weixin.qiyehuo.com/api/recruit_manage_upfile" :mul="false"
                bus="ysyupfile" acc=".jpeg,.jpg,.png,.pdf" :acce="['img','pdf']" /> -->
              </div>
            </el-card>
            <el-card shadow="always" style="margin-top:0.2rem">
              <div slot="header" class="clearfix">
                <span>内容</span>
              </div>
              <div style="white-space:nowrap;">
                <!-- <el-form-item label="部门" prop="branch_id" style="display:inline-block;width:50%">
                <el-select v-model="categoryForm.branch_id" placeholder="请选择"
                  @click.native="getUser" size="mini" clearable filterable style="width:100%">
                  <el-option v-for="reg in branch" :key="reg.id" :label="reg.name"
                    :value="reg.id"></el-option>
                </el-select>
              </el-form-item> -->
                <el-form-item label="名称" prop="body" style="display:inline-block;width:100%">
                  <el-input v-model.trim="categoryForm.body" size="mini" clearable></el-input>
                </el-form-item>
              </div>
            </el-card>
            <el-card shadow="always" style="margin-top:0.2rem">
              <div slot="header" class="clearfix">
                <span>其他</span>
              </div>
              <div style="white-space:nowrap;">
                <el-form-item label="是否显示" prop="display" style="display:inline-block;width:50%">
                  是
                  <el-switch v-model="categoryForm.display" active-color="#ff4949" inactive-color="#13ce66">
                  </el-switch>
                  否
                </el-form-item>
                <el-form-item label="排序" prop="sort" style="display:inline-block;width:50%">
                  <el-input v-model.trim="categoryForm.sort" size="mini" clearable></el-input>
                </el-form-item>
              </div>
              <!-- <el-form-item label="面试官" prop="interviewer">
              <el-select v-model="categoryForm.interviewer" @click.native="getAdminUser" multiple
                placeholder="请选择" style="width: 100%" size="mini" clearable filterable>
                <el-option v-for="item in options_adminUsers" :key="item.id" :label="item.username"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            </el-card>
            <div style="text-align: right;margin-top: 0.2rem;">
              <el-button type="primary" size="mini" @click="submitForm('categoryForm')">保存</el-button>
            </div>
          </el-form>
        </div>
      </el-drawer>
      <el-drawer title="修改" :visible.sync="categoryEditDrawer" :direction="direction" :before-close="handleClose"
        size="40%">
        <div style="padding: 0.2em 1.4em; margin-top: -17px">
          <el-form :model="editCategoryForm" :rules="rules" ref="editCategoryForm" label-width="100px">
            <el-form-item label="分类名称" prop="categoryId">
              <el-input v-model="editCategoryForm.categoryId" size="mini"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否显示" prop="display">
				是
				<el-switch
				  v-model="ifDisplay"
				  active-color="#ff4949"
				  inactive-color="#13ce66"
				>
				</el-switch>
				否
			  </el-form-item> -->
            <div style="text-align: right">
              <el-button type="primary" size="mini" @click="editSubmitForm('editCategoryForm')">修改</el-button>
            </div>
          </el-form>
        </div>
      </el-drawer>
      <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl" size="50%">
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <company-info :companyId="companyComId"></company-info>
          </el-row>
        </div>
      </el-drawer>
      <el-dialog title="待审核信息" :visible.sync="examineDialog" fullscreen @close="clearExamineParams">
        <div style="padding: 0.5rem, 1rem">
          <el-table max-height="650" :data="examineData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
              background: '#ecf4ff',
              color: '#333',
              fontWeight: '900',
              fontSize: '0.28rem'
            }">
            <el-table-column prop="id" label="序号" width="80" align="center" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="company_name" label="公司名称" width="200" fixed="left" align="center">
            </el-table-column>
            <el-table-column prop="" label="是否1-2个月内到期" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link style="color: #f56c6c" v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth">是</el-link>
                <span v-if="scope.row.fin_reg &&
                  scope.row.fin_reg.inNearTwoMonth === false
                  ">否</span>
                <span style="color: #f56c6c; margin-left: 0.1rem"
                  v-if="scope.row.fin_reg && scope.row.fin_reg.inNearTwoMonth">{{ scope.row.fin_reg.end_time }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="待办事项是否完成" width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link style="color: #f56c6c" @click="openUnMatterOvered(scope.row.id)"
                  v-if="scope.row.matterOvered !== null && scope.row.matterOvered">未完成</el-link>
                <span v-if="scope.row.matterOvered !== null && !scope.row.matterOvered
                  ">完成</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="是否有企业微信群" width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link style="color: #f56c6c" v-if="scope.row.wx_work_chat">是</el-link>
                <span v-else scope.row.matterOvered>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="" width="280" show-overflow-tooltip align="center">
              <!-- label="是否已检查群内近30天的聊天记录" -->
              <template slot="header">
                <span>
                  <!-- <el-checkbox
					  v-model="groupInput"
					  @change="checkedgroup"
					></el-checkbox> -->
                  群内人员是否存在被交接人</span>
              </template>
              <template slot-scope="scope">
                <!-- <el-checkbox
				  v-if="scope.row.wx_work_chat"
					v-model="groupInputSon[scope.row.id]"
					@change="groupChange($event, scope.row.id)"
				  ></el-checkbox> -->
                <el-link style="color: #f56c6c" v-if="scope.row.examine_group && scope.row.wx_work_chat">是</el-link>
                <span v-if="!scope.row.examine_group && scope.row.wx_work_chat">否</span>
              </template>
            </el-table-column>
            <el-table-column prop="" width="280" show-overflow-tooltip align="center">
              <!-- label="是否已检查群内近30天的聊天记录" -->
              <template slot="header">
                <span>
                  <!-- <el-checkbox
					  v-model="chatInput"
					  @change="checkedChat"
					></el-checkbox> -->
                  是否已检查群内近30天的聊天记录</span>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.examine_chat">是</span>
                <span v-else style="color: #f56c6c">否</span>
                <!-- <el-checkbox
					v-model="chatInputSon[scope.row.id]"
					@change="chatChange($event,scope.row.id)"
				  ></el-checkbox> -->
              </template>
            </el-table-column>
            <el-table-column prop="" width="270" show-overflow-tooltip align="center">
              <!-- label="是否已进行财务报表及报税检查" -->
              <template slot="header">
                <span>
                  <!-- <el-checkbox
					  v-model="taxInput"
					  @change="checkedTax"
					></el-checkbox> -->
                  是否已进行财务报表及报税检查</span>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.examine_tax">是</span>
                <span v-else style="color: #f56c6c">否</span>
                <!-- <el-checkbox v-model="taxInputSon[scope.row.id]" @change="taxChange($event,scope.row.id)"></el-checkbox> -->
              </template>
            </el-table-column>
            <el-table-column prop="" label="交接职位及新人员" width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <p v-for="(value, key) in scope.row.position" :key="key">
                  {{ key + ":" + value }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="" width="220" show-overflow-tooltip align="center">
              <!-- label="是否已进行财务报表及报税检查" -->
              <template slot="header">
                <span>
                  <!-- <el-checkbox
					  v-model="taxInput"
					  @change="checkedTax"
					></el-checkbox> -->
                  审核通过请勾选</span>
                <i style="margin-top: 0.1rem; color: #e6a23c" class="el-icon-s-opportunity">勾选的同时会自动完成交接</i>
              </template>
              <!-- <template slot-scope="scope">
				<el-checkbox
				  v-if="scope.row.is_examined"
				  v-model="examine[scope.row.id]"
				  @change="examineChange($event, scope.row.id, scope.$index)"
				  disabled
				  checked
				></el-checkbox>
				<el-checkbox
				  v-else
				  v-model="examine[scope.row.id]"
				  @change="examineChange($event, scope.row.id, scope.$index)"
				></el-checkbox>
			  </template> -->
              <template slot-scope="scope">
                <input type="checkbox" v-if="scope.row.is_examined"
                  @change="examineChange($event, scope.row.id, scope.$index)" disabled checked />
                <input type="checkbox" v-else @change="examineChange($event, scope.row.id, scope.$index)" />
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @size-change="handleSizeChange_inside" @current-change="handleCurrentChange_inside"
              :current-page.sync="npage_inside" :page-sizes="[10, 15, 30, 50, 100]" :page-size="pageSize_inside"
              layout="total, sizes, prev, pager, next, jumper" :total="total_inside" background>
            </el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-drawer title="" :visible.sync="distributeDrawer" direction="rtl" :before-close="handleCloseDis" size="50%">
        <template slot="title">
          <span style="color: #409eff; font-size: 0.3rem">反馈</span>
        </template>
        <div style="padding: 0.5rem 1rem">
          <el-form :model="distributeForm" :rules="rules" ref="distributeForm" label-width="108px">
            <el-form-item label="反馈内容" prop="feedback">
              <el-input size="mini" type="textarea" v-model="distributeForm.feedback" style="white-space: pre"></el-input>
            </el-form-item>
            <el-form-item label="上传截图/文件" prop="url">
              <el-upload action="https://weixin.qiyehuo.com/api/handover_examine/upfile" :headers="headers" multiple
                ref="uploadMutiple" :file-list="fileList" :limit="limit" :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess" :on-change="handleAvatarChange" :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove">
                <el-button size="mini" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: #909399; margin-top: -0.1rem">
                  单次上传最多10个文件或图片
                </div>
              </el-upload>
              <!-- <ul>
				<li v-for="item in fileNameList" :key="item" :title="item"><span class="notOver">{{item}}</span></li>
			  </ul> -->
              <div style="margin-top: 0.2rem">
                <span><i class="el-icon-s-opportunity" style="color: #fb894c">点击下方，Ctrl+v上传</i></span>
              </div>
              <!-- <div id="preview" @paste="handlePaste">
				<el-input
				  size="mini"
				  type="textarea"
				  placeholder="先点击此处 再按Ctrl+V 粘贴至此处"
				  max="0"
				></el-input>
			  </div> -->
              <div id="preview" @paste="handlePaste" style="
  						  border: 3px dashed #409eff;
  						  border-radius: 15px;
  						  text-indent: 2em;
  						">
                <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
              </div>
            </el-form-item>
            <el-form-item label="交接进度" prop="progress">
              <el-radio-group v-model="distributeForm.progress" size="mini">
                <el-radio-button label="1">交接中</el-radio-button>
                <el-radio-button label="2">交接完成</el-radio-button>
                <el-radio-button label="3">交接失败</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div style="text-align: right">
              <el-button type="primary" size="mini" @click="submitDisForm('distributeForm')">提交</el-button>
            </div>
          </el-form>
          <div style="margin-bottom: 0.28rem; color: #409eff" v-if="FOptions.length !== 0">
            反馈记录
          </div>
          <div class="block">
            <el-timeline>
              <el-timeline-item :timestamp="item.created_at" placement="top" v-for="item in FOptions" :key="item.id">
                <el-card>
                  <h4 style="margin-bottom: 0.28rem">
                    <span>反馈内容：</span><span>{{ item.feedback }}</span>
                  </h4>
                  <!-- <h4 style="margin-bottom: 0.28rem">
					<span>预计完成时间：</span><span>{{ item.es_time }}</span>
				  </h4> -->
                  <p style="margin-bottom: 0.28rem">
                    <span>反馈人：</span><span>{{ item.feedbacker }}</span>
                  </p>
                  <div v-for="i in item.file" :key="i.id">
                    <div v-if="i.type === 'img'" style="margin-bottom: 0.3rem">
                      <p style="margin-bottom: 0.28rem">
                        <el-tooltip class="item" effect="dark" :content="i.name" placement="top">
                          <span style="
  									  display: block;
  									  width: 2.5rem;
  									  overflow: hidden;
  									  text-overflow: ellipsis;
  									  white-space: nowrap;
  									">{{ i.name }}</span>
                        </el-tooltip>
                      </p>
                      <p>
                        <el-image :preview-src-list="[i.url]" :src="i.url"
                          style="cursor: pointer; width: 150px; height: 150px">
                        </el-image>
                      </p>
                    </div>
                    <div v-if="i.type === 'file'">
                      <p style="margin-bottom: 0.28rem">
                        <el-tooltip class="item" effect="dark" :content="i.name" placement="top">
                          <span style="
  									  display: block;
  									  width: 2.5rem;
  									  overflow: hidden;
  									  text-overflow: ellipsis;
  									  white-space: nowrap;
  									" v-down="i.url"><el-link style="color: #409eff">{{
  									  i.name
  									}}</el-link></span>
                        </el-tooltip>
                      </p>
                      <!-- <p>
							<img :src="i.url" width="150px" height="150px" />
						  </p> -->
                    </div>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-drawer>
      <el-drawer title="未完成的待办事项" :visible.sync="unMatterOveredDrawer" direction="rtl" size="50%" :modal="false"
        @close="closeUnMatterOveredDrawer">
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-table :data="unMatterOveredData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
              background: '#ecf4ff',
              color: '#333',
              fontWeight: '900',
              fontSize: '0.28rem'
            }" max-height="650">
            <el-table-column prop="company.company_name" label="公司名称" width="220" fixed="left">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.company.company_name" placement="top">
                  <el-link style="
  							  display: block;
  							  color: #409eff;
  							  font-size: 0.28rem;
  							  cursor: pointer;
  							  white-space: nowrap;
  							  overflow: hidden;
  							  text-overflow: ellipsis;
  							" @click="openCompanyCom_examine(scope.row)">
                    {{ scope.row.company.company_name }}
                  </el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
                    style="margin-left: 0.1rem; cursor: pointer"
                    @click="copySome(scope.row.company.company_name)"></i></el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="typeiner.username" label="创建人" width="150">
              <template slot-scope="scope">
                <p>{{ scope.row.typeiner.username }}</p>
                <p>{{ scope.row.created_at }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="completed_at" label="ETA处理时间" width="280">
            </el-table-column>
            <el-table-column prop="donner.username" label="办理人" width="120">
              <template slot-scope="scope">
                <div v-if="!scope.row.overTime">
                  <span v-if="!scope.row.donner">
                    <!-- <span>
					  <el-tooltip
						class="item"
						effect="dark"
						content="点击添加办理人"
						placement="top"
					  >
						<el-popover
						  placement="left-start"
						  width="300"
						  trigger="click"
						>
						  <el-form
							:model="addAddressForm"
							:rules="addressRules"
							ref="addAddressForm"
							label-width="80px"
							style="padding-right: 0.33rem"
						  >
							<el-form-item label="办理人" prop="doner_id">
							  <el-select
								v-model="addAddressForm.doner_id"
								placeholder="请选择"
								size="mini"
								@click.native="loadAdminUser_a"
								filterable
								style="width: 100%"
								clearable
							  >
								<el-option
								  v-for="item in adminUserOptions_a"
								  :key="item.id"
								  :label="item.username"
								  :value="item.id"
								>
								</el-option>
							  </el-select>
							</el-form-item>
						  </el-form>
						  <div
							style="
							  margin-top: 0.15rem;
							  text-align: right;
							  padding-right: 0.33rem;
							"
						  >
							<el-button
							  type="primary"
							  size="mini"
							  @click="saveChange('addAddressForm', scope.row.id)"
							  >保存
							</el-button>
						  </div>
						  <i
							slot="reference"
							style="
							  cursor: pointer;
							  font-size: 0.38rem;
							  color: #409eff;
							"
							class="el-icon-circle-plus-outline"
						  ></i>
						</el-popover>
					  </el-tooltip>
					</span> -->
                  </span>
                  <span v-else>
                    <span>
                      {{ scope.row.donner.username }}
                    </span>
                  </span>
                </div>
                <div v-if="scope.row.overTime">
                  <span v-if="!scope.row.donner">
                    <!-- <span>
					  <el-tooltip
						class="item"
						effect="dark"
						content="点击添加办理人"
						placement="top"
					  >
						<el-popover
						  placement="left-start"
						  width="300"
						  trigger="click"
						>
						  <el-form
							:model="addAddressForm"
							:rules="addressRules"
							ref="addAddressForm"
							label-width="80px"
							style="padding-right: 0.33rem"
						  >
							<el-form-item label="办理人" prop="doner_id">
							  <el-select
								v-model="addAddressForm.doner_id"
								placeholder="请选择"
								size="mini"
								@click.native="loadAdminUser_a"
								filterable
								style="width: 100%"
								clearable
							  >
								<el-option
								  v-for="item in adminUserOptions_a"
								  :key="item.id"
								  :label="item.username"
								  :value="item.id"
								>
								</el-option>
							  </el-select>
							</el-form-item>
						  </el-form>
						  <div
							style="
							  margin-top: 0.15rem;
							  text-align: right;
							  padding-right: 0.33rem;
							"
						  >
							<el-button
							  type="primary"
							  size="mini"
							  @click="saveChange('addAddressForm', scope.row.id)"
							  >保存
							</el-button>
						  </div>
						  <i
							slot="reference"
							style="
							  cursor: pointer;
							  font-size: 0.38rem;
							  color: #409eff;
							"
							class="el-icon-circle-plus-outline"
						  ></i>
						</el-popover>
					  </el-tooltip>
					</span> -->
                    <span>
                      <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                        <i class="el-icon-warning" style="
  									font-size: 0.35rem;
  									color: #f56c6c;
  									margin-left: 0.25rem;
  								  "></i>
                      </el-tooltip>
                    </span>
                  </span>
                  <span v-else>
                    <span>
                      {{ scope.row.donner.username }}
                    </span>
                    <span>
                      <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                        <i class="el-icon-warning" style="
  									font-size: 0.35rem;
  									color: #f56c6c;
  									margin-left: 0.25rem;
  								  "></i>
                      </el-tooltip>
                    </span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="donner_w.username" label="外勤办理人" width="120">
              <template slot-scope="scope">
                <div v-if="!scope.row.overTime">
                  <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                    <!-- <span>
					  <el-tooltip
						class="item"
						effect="dark"
						content="点击添加办理人(外勤)"
						placement="top"
					  >
						<el-popover
						  placement="left-start"
						  width="300"
						  trigger="click"
						>
						  <el-form
							:model="addAddressFormW"
							:rules="addressRules"
							ref="addAddressFormW"
							label-width="100px"
							style="padding-right: 0.31rem"
						  >
							<el-form-item label="办理人(外勤)" prop="doner_id_w">
							  <el-select
								v-model="addAddressFormW.doner_id_w"
								placeholder="请选择"
								size="mini"
								@click.native="loadAdminUser_a_w"
								filterable
								style="width: 100%"
								clearable
							  >
								<el-option
								  v-for="item in adminUserOptions_a_w"
								  :key="item.id"
								  :label="item.username"
								  :value="item.id"
								>
								</el-option>
							  </el-select>
							</el-form-item>
						  </el-form>
						  <div
							style="
							  margin-top: 0.15rem;
							  text-align: right;
							  padding-right: 0.31rem;
							"
						  >
							<el-button
							  type="primary"
							  size="mini"
							  @click="
								saveChange_aw('addAddressFormW', scope.row.id)
							  "
							  >保存
							</el-button>
						  </div>
						  <i
							slot="reference"
							style="
							  cursor: pointer;
							  font-size: 0.38rem;
							  color: #409eff;
							"
							class="el-icon-circle-plus-outline"
						  ></i>
						</el-popover>
					  </el-tooltip>
					</span> -->
                  </span>
                  <span v-if="scope.row.donner_w">{{
                    scope.row.donner_w.username
                  }}</span>
                </div>
                <div v-if="scope.row.overTime">
                  <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                    <!-- <span>
					  <el-tooltip
						class="item"
						effect="dark"
						content="点击添加办理人(外勤)"
						placement="top"
					  >
						<el-popover
						  placement="left-start"
						  width="300"
						  trigger="click"
						>
						  <el-form
							:model="addAddressFormW"
							:rules="addressRules"
							ref="addAddressFormW"
							label-width="100px"
							style="padding-right: 0.31rem"
						  >
							<el-form-item label="办理人(外勤)" prop="doner_id_w">
							  <el-select
								v-model="addAddressFormW.doner_id_w"
								placeholder="请选择"
								size="mini"
								@click.native="loadAdminUser_a_w"
								filterable
								style="width: 100%"
								clearable
							  >
								<el-option
								  v-for="item in adminUserOptions_a_w"
								  :key="item.id"
								  :label="item.username"
								  :value="item.id"
								>
								</el-option>
							  </el-select>
							</el-form-item>
						  </el-form>
						  <div
							style="
							  margin-top: 0.15rem;
							  text-align: right;
							  padding-right: 0.31rem;
							"
						  >
							<el-button
							  type="primary"
							  size="mini"
							  @click="
								saveChange_aw('addAddressFormW', scope.row.id)
							  "
							  >保存
							</el-button>
						  </div>
						  <i
							slot="reference"
							style="
							  cursor: pointer;
							  font-size: 0.38rem;
							  color: #409eff;
							"
							class="el-icon-circle-plus-outline"
						  ></i>
						</el-popover>
					  </el-tooltip>
					</span> -->
                    <span>
                      <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                        <i class="el-icon-warning" style="
  									  font-size: 0.35rem;
  									color: #f56c6c;
  									margin-left: 0.25rem;
  								  "></i>
                      </el-tooltip>
                    </span>
                  </span>
                  <span v-if="scope.row.donner_w">
                    <span>{{ scope.row.donner_w.username }}</span>
                    <span>
                      <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                        <i class="el-icon-warning" style="
  									font-size: 0.35rem;
  									color: #f56c6c;
  									margin-left: 0.25rem;
  								  "></i>
                      </el-tooltip>
                    </span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="urge_count" label="催办次数" width="120">
			  <template slot-scope="scope">
				<div style="padding: 0.28rem 0" v-if="scope.row.urge_count > 0">
				  <el-badge :value="scope.row.urge_count" class="item">
					<el-button size="mini" @click="openUrgeCount(scope.row.urges)"
					  >催办次数</el-button
					>
				  </el-badge>
				</div>
			  </template>
			</el-table-column> -->
            <el-table-column prop="feed_count" label="反馈次数" width="80">
            </el-table-column>
            <el-table-column prop="feed[0].created_at" label="最后一次反馈时间" width="160">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="点击查看" placement="top" v-if="scope.row.feed.length > 0">
                  <el-popover placement="right" width="300" trigger="click">
                    <el-row type="flex" class="row-bg" justify="center">
                      <el-col :span="10">反馈人:</el-col>
                      <el-col :span="14" style="font-weight: normal">
                        {{ scope.row.feed[0].feedbacker }}
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="center">
                      <el-col :span="10">反馈内容:</el-col>
                      <el-col :span="14" style="font-weight: normal">
                        {{ scope.row.feed[0].feedback }}
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="row-bg" justify="center">
                      <el-col :span="10">预计完成时间:</el-col>
                      <el-col :span="14" style="font-weight: normal">
                        {{ scope.row.feed[0].es_time }}
                      </el-col>
                    </el-row>
                    <i slot="reference" style="cursor: pointer; font-size: 0.28rem; color: #409eff">{{
                      scope.row.feed[0].created_at }}</i>
                  </el-popover>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="type_name" label="服务类型" width="100">
            </el-table-column>
            <!-- <el-table-column prop="order_num" label="订单号" width="190">
			  <template slot-scope="scope">
				<span v-if="scope.row.order_num">
				  <el-link
					style="color: #409eff"
					@click="
					  handleOrderInfo(
						scope.row.orderId,
						scope.row.company.company_name
					  )
					"
					>{{ scope.row.order_num }}</el-link
				  >
				</span>
				<span style="color: #f56c6c" v-else>
				  <el-tooltip
					class="item"
					effect="dark"
					content="点击绑定订单"
					placement="top"
				  >
					<el-popover
					  @hide="clearSelf"
					  placement="bottom"
					  width="300"
					  trigger="click"
					>
					  <el-input
						v-model="table_OrderData"
						size="mini"
						placeholder="输入订单号绑定订单"
					  ></el-input>
					  <div style="margin-top: 0.15rem; text-align: right">
						<el-button
						  type="primary"
						  size="mini"
						  @click="bindOrderNum(scope.row.id)"
						  >保存</el-button
						>
					  </div>
					  <span
						slot="reference"
						style="cursor: pointer; color: #f56c6c"
						>无订单号</span
					  >
					</el-popover>
				  </el-tooltip>
				</span>
			  </template>
			</el-table-column> -->
            <el-table-column prop="title_name" label="事项" width="230">
            </el-table-column>
            <el-table-column prop="diser.username" label="分配人" width="150">
              <template slot-scope="scope">
                <p v-if="scope.row.diser">{{ scope.row.diser.username }}</p>
                <p>{{ scope.row.distribute_at }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="progress" label="进度" width="150">
              <template slot-scope="scope">
                <div v-if="!scope.row.overTimeD">
                  <p>{{ scope.row.progress }}</p>
                  <p v-if="scope.row.progress === '已完成'">
                    {{ scope.row.done_at }}
                  </p>
                  <!-- <p v-if="scope.row.screen.length > 0">
					<el-link
					  style="color: #409eff"
					  @click.native="openImageDrawer(scope.row.screen)"
					  ><span>相关截图/文件</span>
					</el-link>
				  </p> -->
                </div>
                <div v-if="scope.row.overTimeD">
                  <p>
                    <span>{{ scope.row.progress }}</span>
                    <span>
                      <el-tooltip class="item" effect="dark" content="办理超时" placement="top">
                        <i class="el-icon-warning" style="
  									font-size: 0.35rem;
  									color: #f56c6c;
  									margin-left: 0.25rem;
  								  "></i>
                      </el-tooltip>
                    </span>
                  </p>
                  <p v-if="scope.row.progress === '已完成'">
                    {{ scope.row.done_at }}
                  </p>
                  <!-- <p v-if="scope.row.screen.length > 0">
					<el-link
					  @click.native="openImageDrawer(scope.row.screen)"
					  style="color: #409eff"
					  >相关截图/文件</el-link
					>
				  </p> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
            </el-table-column>
            <!-- <el-table-column label="操作" fixed="right" width="220">
			  <template slot-scope="scope">
				<el-tooltip
				  class="item"
				  effect="dark"
				  content="编辑"
				  placement="top"
				>
				  <el-button
					@click.native.prevent="openEdit(scope.row)"
					type="primary"
					size="mini"
					icon="el-icon-edit"
					circle
				  >
				  </el-button>
				</el-tooltip>
				<el-tooltip
				  class="item"
				  effect="dark"
				  content="分配"
				  placement="top"
				>
				  <el-button
					@click.native.prevent="openDistribute(scope.row)"
					type="success"
					size="mini"
					icon="el-icon-user"
					circle
				  >
				  </el-button>
				</el-tooltip>
				<el-tooltip class="item" effect="dark" content="" placement="top">
				  <template slot="content">
					<p>催办</p>
					<p>催办时间间隔为24h</p>
				  </template>
				  <el-button
					@click.native.prevent="openUrge(scope.row)"
					type="danger"
					size="mini"
					icon="el-icon-message-solid"
					circle
					:disabled="
					  (scope.row.urge.length > 0
						? scope.row.urge[0].notTime
						: false) || scope.row.progress === '已完成'
					"
				  >
				  </el-button>
				</el-tooltip>
				<el-tooltip
				  class="item"
				  effect="dark"
				  content="企业微信群聊天记录"
				  placement="top"
				>
				  <el-button
					type="warning"
					@click="
					  handleWxChatOpen(
						scope.row.wx_work_chat_com,
						scope.row.company.company_name
					  )
					"
					size="mini"
					icon="el-icon-s-comment"
					circle
					:disabled="scope.row.wx_work_chat_com ? false : true"
				  >
				  </el-button>
				</el-tooltip>
				<el-tooltip
				  class="item"
				  effect="dark"
				  content="电话联系记录"
				  placement="top"
				>
				  <el-button
					type="primary"
					size="mini"
					icon="el-icon-phone-outline"
					circle
					@click="handCallLogsOpen(scope.row)"
				  ></el-button>
				</el-tooltip>
			  </template>
			</el-table-column> -->
          </el-table>
          <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @size-change="handleSizeChange_un" @current-change="handleCurrentChange_un"
              :current-page.sync="npage_un" :page-sizes="[10, 15, 30, 50, 100]" :page-size="pageSize_un"
              layout="total, sizes, prev, pager, next, jumper" :total="total_un" background>
            </el-pagination>
          </div>
        </div>
      </el-drawer>
      <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
        <template slot="title">
          <span style="color: #409EFF;font-size: large"></span>
        </template>
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <make-phone :phone1="phoneFrom_phone"></make-phone>
          </el-row>
        </div>
      </el-drawer>
      <!-- <el-tabs @tab-click="handleClick">
      <el-tab-pane label="全部订单" name="first"></el-tab-pane>
      <el-tab-pane label="已支付" name="second"></el-tab-pane>
      <el-tab-pane label="未支付" name="third"></el-tab-pane>
    </el-tabs> -->
      <el-table max-height="650" :data="categoryData" style="width: 100%; margin-top: 10px" border size="mini"
        :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem'
        }" id="forStyle">
        <!-- <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="录入人">
              <span>{{ scope.row.typeiner_name ? scope.row.typeiner_name: '' }}</span>
            </el-form-item>
            <el-form-item label="应聘者简历">
              <el-image
                v-if="scope.row.biographical_url && scope.row.biographical_url.image_info.is_img"
                style="width: 200px; height: 200px"
                :src="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                :preview-src-list="scope.row.biographical_url ? [scope.row.biographical_url.image_info.url] : []">
              </el-image>
              <el-tooltip v-else class="item" effect="dark"
                :content="scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' "
                placement="top">
                <el-link type="primary" style="cursor:pointer"
                  :href="scope.row.biographical_url ? scope.row.biographical_url.image_info.url : ''"
                  target="_blank">
                  <span
                    style="width:200px;display:block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden">{{ scope.row.biographical_url ? scope.row.biographical_url.image_info.name : '' }}</span>
                </el-link>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column> -->
        <el-table-column prop="id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <el-input v-if="toEdit[scope.row.id] === true" :ref="'editinput' + scope.row.id" size="mini"
              v-model.trim="list_edit[scope.row.id]" @blur="toEdit = []"></el-input>
            <el-tooltip v-else class="item" effect="dark" content="点击修改" placement="top">
              <span @click="alert_edit_input(scope.row.id, scope.row.name)">{{ scope.row.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="cate_name.name" label="所属分类">
          <template slot-scope="scope">
            <el-input v-if="toEdit_cate[scope.row.id] === true" :ref="'editinputcate' + scope.row.id" size="mini"
              v-model.trim="list_edit_cate[scope.row.id]" @blur="toEdit_cate = []"></el-input>
            <el-tooltip v-else class="item" effect="dark" content="点击修改" placement="top">
              <span @click="alert_edit_input_cate(scope.row.id, scope.row.cate_name.name, scope.row.cate_id)">{{
                scope.row.cate_name.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="是否显示">
          <template slot-scope="scope">
            是
            <el-switch v-model="ListIfDisplay[scope.row.id]" active-color="#ff4949" inactive-color="#13ce66"
              @change="editListRadioC($event, scope.row.id)">
            </el-switch>
            否
          </template>
        </el-table-column>
        <el-table-column label="排序">
          <template slot-scope="scope">
            <el-input :ref="'list' + scope.row.id" type="number" size="mini" v-model.trim="listSort[scope.row.id]"
              @click.native="needId = scope.row.id"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="user_info.phone" label="支付人手机">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.user_info.phone" placement="top">
            <span class="hide-style"><el-link style="color: #409EFF;cursor: pointer"
                @click="openPhoneFromDraw(scope.row.user_info.phone)">{{ scope.row.user_info.phone.substring(0,5) + '...' }}</el-link>
              <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                <i @click="makePhone(scope.row.user_info.phone)" class="el-icon-phone-outline"
                  style="color: #409EFF;cursor:pointer;"></i>
              </el-tooltip>
            </span>
          </el-tooltip>
        </template>
      </el-table-column> -->
        <!-- <el-table-column label="应聘职位">
        <template slot-scope="scope">
          <span v-if="scope.row.station !== '暂未填写'">{{ scope.row.station }}</span>
          <span v-else style="color:#F56C6C">{{ scope.row.station }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="meet_place" label="面试地点">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.meet_place }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="meet_at" label="面试时间">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.meet_at }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="面试官">
        <template slot-scope="scope">
          <span v-if="scope.row.interviewer_name">
            {{ scope.row.interviewer_name.join(',') }}
          </span>
          <span v-else style="color:#F56C6C">暂未填写</span>
        </template>
      </el-table-column>
      <el-table-column label="支付时间">
        <template slot-scope="scope">
          <span>{{ scope.row.send_pay_date ? scope.row.send_pay_date : '---' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="飞书链接">
        <template slot-scope="scope">
          <span v-if="scope.row.feishuurl">
            <el-link type="primary" @click.native="openUrl(scope.row.feishuurl)">打开链接</el-link>
          </span>
          <span v-else style="color:#F56C6C">暂未设置链接</span>
        </template>
      <el-table-column prop="created_at" label="创建时间"></el-table-column>
      </el-table-column> -->
        <!-- <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top"
            v-if="scope.row.status === 3">
            <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
              icon="el-icon-document-checked" circle disabled>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="全部审核通过" placement="top" v-else>
            <el-button @click.native.prevent="editRow(scope.row.id)" type="primary" size="mini"
              icon="el-icon-document-checked" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="提交反馈" placement="top">
            <el-button @click.native.prevent="openExamineFeed(scope.row.id)" type="warning"
              size="mini" icon="el-icon-finished" circle>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column> -->
      </el-table>
      <div class="block" style="margin-top: 10px; text-align: right">
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="npage"
          layout="sizes, total, prev, pager, next, jumper" :total="total" :page-sizes="[10, 15, 30, 50, 100]"
          :page-size="categoryPerPage" background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import upfile from '../../common/UpFile.vue'
import Vue from 'vue'
import CompanyInfo from 'common/CompanyInfo'
import { fscDate } from '../../../static/mixins/fastChooseDate'
import MakePhone from 'common/MakePhone'
export default {
  name: 'QiYeHuo',
  mixins: [fscDate],
  components: { CompanyInfo, upfile, MakePhone },
  data() {
    Vue.directive('down', {
      inserted: (el, binding) => {
        el.style.cssText = 'cursor: pointer;color:write;'
        el.addEventListener('click', () => {
          // console.log(binding.value)
          let link = document.createElement('a')
          let image = document.createElement('image')
          let url = binding.value
          let downloadName = url.slice(url.lastIndexOf('/') + 1)
          // console.log(downloadName);
          // 这里是将url转成blob地址，
          image.setAttribute('crossOrigin', 'anonymous') // 这句可以解决跨域问题
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              link.href = URL.createObjectURL(blob)
              // console.log(link.href)
              link.download = downloadName
              document.body.appendChild(link)
              link.click()
            })
        })
      },
    })
    let checkPhone = (rule, value, callback) => {
      if (value !== '') {
        let reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输⼊有效的⼿机号码'))
        }
      }
      callback()
    }
    let numReg = /^[0-9]*$/
    let numRe = new RegExp(numReg)
    let checkDuration = (rule, value, callback) => {
      if (value.length > 0) {
        if (!numRe.test(value)) {
          return callback(new Error('请输入数字！'))
        }
      }
      callback()
    }
    return {
      list_edit: [],
      list_edit_cate: [],
      doEditInputId_cate: '',
      toEdit: [],
      doEditInputId: '',
      doEditInputId_cate_id: '',
      timer_edit_body: '',
      timer_edit_cate: '',
      toEdit_cate: [],
      phoneFrom_phone: [],
      phoneFromDraw: false,
      timer: '',
      timer_sort: '',
      needType: '',
      companyComId: null,
      companyInfoDrawer: false,
      unMatterOveredId: '',
      pageSize_un: 10,
      total_un: 0,
      npage_un: 1,
      unMatterOveredData: [],
      unMatterOveredDrawer: false,
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      change: false,
      aboutExId: '',
      FOptions: [],
      needUrl: [],
      fileList: [],
      limit: 10,
      distributeForm: {
        feedback: '',
        progress: '1',
      },
      examineFeed: {
        remark: '',
      },
      distributeDrawer: false,
      exmined: [],
      examine: [],
      examineId: '',
      needId: '',
      examineDialog: false,
      pageSize_inside: 10,
      nowPage_inside: 1,
      total_inside: 0,
      npage_inside: 1,
      examineData: [],
      searchArr: {
        phone_order: '',
        created_at: '',
        send_pay_date: '',
      },
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      branch: [],
      options_adminUsers: [],
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        },
      },
      categoryForm: {
        sort: '',
        display: false,
        body: '',
        name: '',
        phone: '',
        branch_id: '',
        station: '',
        meetAt: '',
        meet_place: '',
        feishuurl: '',
      },
      editCategoryForm: {
        categoryId: '',
        category_name: '',
        display: false,
      },
      itemCate_options: [],
      addAddressForm: {
        addressee: '',
        address_phone: '',
        address: '',
      },
      addressRules: {
        addressee: [
          { required: true, message: '请输入分类', trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
        address_phone: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' },
        ],
      },
      rules: {
        name: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        sort: [{ validator: checkDuration, trigger: 'blur' }],
        body: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' },
        ],
        meetAt: [
          { required: true, message: '请选择面试时间', trigger: 'blur' },
        ],
        meet_place: [
          { required: true, message: '请选择面试地点', trigger: 'blur' },
        ],
        station: [
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur',
          },
        ],
        feishuurl: [
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    collapse() {
      return this.$store.state.collapse
    },
  },
  mounted() {
    this.loadTable()
  },
  beforeDestroy() {
    //
  },
  watch: {
    'searchArr.phone_order': {
      handler() {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.npage = 1
          this.loadTable()
        }, 300)
      },
      deep: true,
    },
    categoryData(n) {
      n.forEach((item) => {
        if (item.display === 2) {
          this.ListIfDisplay[item.id] = true
        }
        this.listSort[item.id] = item.sort
      })
    },
    listSort: {
      handler(n) {
        if (this.timer_sort) {
          clearTimeout(this.timer_sort)
        }
        this.timer_sort = setTimeout(() => {
          this.$nextTick(() => {
            this.editListSortC(n)
          })
        }, 600)
      },
      deep: true,
    },
    list_edit: {
      handler(n) {
        if (this.timer_edit_body) {
          clearTimeout(this.timer_edit_body)
        }
        this.timer_edit_body = setTimeout(() => {
          this.$nextTick(() => {
            this.doEditInput(n)
          })
        }, 500)
      },
      deep: true,
    },
    list_edit_cate: {
      handler(n) {
        if (this.timer_edit_cate) {
          clearTimeout(this.timer_edit_cate)
        }
        this.timer_edit_cate = setTimeout(() => {
          this.$nextTick(() => {
            this.doEditInputCate(n)
          })
        }, 500)
      },
      deep: true,
    },
  },
  methods: {
    doEditInput(name) {
      if (!name[this.doEditInputId]) {
        this.$message.warning('输入不能为空!')
        return false
      }
      this.$axios
        .put('api/single_item_edit_body', {
          name,
          id: this.doEditInputId,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.toEdit = []
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    doEditInputCate(name) {
      if (!name[this.doEditInputId_cate]) {
        this.$message.warning('输入不能为空!')
        return false
      }
      this.$axios
        .put('api/single_item_edit_cate', {
          id: this.doEditInputId_cate,
          name,
          cate_id: this.doEditInputId_cate_id,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.toEdit_cate = []
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    alert_edit_input(id, name) {
      this.doEditInputId = id
      this.toEdit = []
      this.toEdit.push(id)
      this.toEdit[id] = true
      this.list_edit[id] = name
      this.$nextTick(() => {
        this.$refs[`editinput${id}`].focus()
      })
    },
    alert_edit_input_cate(id, name, cate_id) {
      this.doEditInputId_cate = id
      this.doEditInputId_cate_id = cate_id
      this.toEdit_cate = []
      this.toEdit_cate.push(id)
      this.toEdit_cate[id] = true
      this.list_edit_cate[id] = name
      this.$nextTick(() => {
        this.$refs[`editinputcate${id}`].focus()
      })
    },
    editListRadioC(e, id) {
      this.$axios
        .put('api/single_item_edit_display', {
          e,
          id,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.loadTable()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    editListSortC(val) {
      let numReg = /^[0-9]*$/
      let numRe = new RegExp(numReg)
      if (val[this.needId].length > 0) {
        if (!numRe.test(val[this.needId])) {
          this.$message.warning('请输入数字!')
          return false
        }
      }
      this.$axios
        .put('api/single_item_edit_sort', {
          val,
          id: this.needId,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$nextTick(() => {
              this.$refs[`list${this.needId}`].focus()
              this.$refs[`list${this.needId}`].blur()
            })
            this.$message.success(data.msg)
            this.loadTable()
          }
        })
        .catch()
    },
    saveChange(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post('api/single_item_add_cate', this.addAddressForm)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                let myEvent = new Event('click')
                document.dispatchEvent(myEvent)
                this.$message.success(data.msg)
                this.resetForm('addAddressForm')
                this.getItem_cate()
              } else {
                this.$message.error(data.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getItem_cate() {
      this.$axios
        .get('api/single_item_get_cate')
        .then(({ data }) => {
          if (data.code === 0) {
            this.itemCate_options = data.data
          }
        })
        .catch()
    },
    openUrl(url) {
      let newPage = this.$router.resolve({
        path: '/documentation',
        query: { url: url },
      })
      window.open(newPage.href, '_blank')
    },
    getAdminUser() {
      this.$axios.get('/api/admin/users').then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.options_adminUsers = data.data.users
          this.roles = data.data.roles
          this.statistical = data.data.statistical
        }
      })
    },
    getUser() {
      this.$axios.get('/api/admin/users').then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.users = data.data.users
          this.roles = data.data.roles
          this.branch = data.data.branch
          this.statistical = data.data.statistical
        }
      })
    },
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement('input')
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput)
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select()
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand('Copy')
      // 清空输入框
      newInput.remove()
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: '复制成功',
        type: 'success',
      })
    },
    copySome(data) {
      this.copy(data)
    },
    handleSizeChange_un(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_un = val
      this.getUnMatterOveredData()
    },
    handleCurrentChange_un(val) {
      this.npage_un = val
      this.getUnMatterOveredData()
    },
    openCompanyCom(row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.id
      })
    },
    openCompanyCom_examine(row) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyComId = row.company_id
      })
    },
    closeUnMatterOveredDrawer() {
      this.unMatterOveredId = ''
      this.unMatterOveredData = []
    },
    getUnMatterOveredData() {
      if (!this.unMatterOveredId) return false
      this.$axios
        .get(
          'api/handover_examine/get_matter_un?page' +
          this.npage_un +
          '&perPage=' +
          this.pageSize_un +
          '&cid=' +
          this.unMatterOveredId
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.unMatterOveredData = data.data.data
            this.total_un = data.data.total
          }
        })
        .catch()
    },
    openUnMatterOvered(id) {
      this.unMatterOveredId = id
      this.getUnMatterOveredData()
      this.unMatterOveredDrawer = true
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / 1024 / 1024 < 100

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
      // this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleAvatarChange(res, file) {
      this.fileList = file
      this.change = true
    },
    handlePictureCardPreview(file) {
      this.fileNameList = file.name
    },
    handleRemove(file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        // if (items[i].type.indexOf('image') !== -1) {
        file = items[i].getAsFile()
        // break
        // }
      }
      // if (!file) {
      //   this.$message.error('粘贴内容非图片')
      //   return
      // }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
    submitDisForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.distributeForm.file = this.needUrl
          this.distributeForm.id = this.aboutExId
          this.$axios
            .post('api/handover_examine/store', this.distributeForm)
            .then(({ data }) => {
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.distributeDrawer = false
                this.$refs.distributeForm.resetFields()
                this.fileList = []
                this.needUrl = []
                this.change = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          return false
        }
      })
    },
    handleSizeChange_inside(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize_inside = val
      this.loadTable_inside()
    },
    handleCurrentChange_inside(val) {
      this.npage_inside = val
      this.loadTable_inside()
    },
    clearExamineParams() {
      let check = document.getElementsByTagName('input')
      let arr = Array.from(check)
      console.log(arr)
      arr.map((item) => {
        item.checked = false
      })
      // for (var i in this.examine) {
      //   this.examine[i] = false
      // }
      // this.examine.map((item, index) => {
      //   this.examine.splice(index, 1)
      // })
      this.examineId = ''
    },
    loadTable_inside() {
      this.$axios
        .get('api/handover_examine/' + this.examineId, {
          params: {
            page: this.npage_inside,
            perpage: this.pageSize_inside,
            // searchItem: this.searcher
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.examineData = data.data.data
            this.total_inside = data.data.total
            // this.loadRadio()
            // this.loadSort()
          }
        })
        .catch()
    },
    examineChange(val, id, index) {
      if (val) {
        this.$axios
          .put('api/handover_examine/' + this.examineId, {
            company_id: id,
          })
          .then(({ data }) => {
            if (data.code === 1) {
              // this.exmined.push(id)
              // this.examineData[index].is_examined = true
              this.loadTable_inside()
              this.loadTable()
              this.$message.success(data.msg)
              //   this.examineData = data.data.data
              //   this.total_inside = data.data.total
              // this.loadRadio()
              // this.loadSort()
            }
          })
          .catch()
      }
    },
    openNameRow(id) {
      this.examineId = id
      this.loadTable_inside()
      this.examineDialog = true
    },
    handleClick(val) {
      if (val.name === 'first') {
        this.npage = 1
        this.needType = ''
        this.loadTable()
      }
      if (val.name === 'second') {
        this.npage = 1
        this.needType = 1
        this.loadTable(1)
      }
      if (val.name === 'third') {
        this.needType = 0
        this.npage = 1
        this.loadTable(0)
      }
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone)
      })
      this.phoneFromDraw = true
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }
      // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
      this.$axios.post('api/admin/call_logs_call', {
        phone
      }).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = []
      done()
    },
    doSearch() {
      this.npage = 1
      this.loadTable(this.needType)
    },
    loadTable() {
      this.$axios
        .get('api/single_item_show_body', {
          params: {
            page: this.npage,
            per_page: this.categoryPerPage,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.categoryData = data.data.data
            this.total = data.data.total
            // this.loadRadio()
            // this.loadSort()
          }
        })
        .catch()
    },
    loadRadio() {
      this.categoryData.map((item) => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort() {
      this.categoryData.map((item) => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange(val) {
      this.npage = val
      this.loadTable(this.needType)
    },
    handleSizeChange(val) {
      this.categoryPerPage = val
      this.loadTable(this.needType)
    },
    editRow(id) {
      this.$axios
        .put('api/handover_examine/all_examined/' + id)
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          }
        })
        .catch()
    },
    searchRemoteCfcategory(query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem(query) {
      this.$axios
        .get('api/single_item_remote_search', {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory() {
      setTimeout(() => {
        this.npage = 1
        this.loadTable()
      })
    },
    categoryIn() {
      this.categoryIndrawer = true
    },
    handleClose(done) {
      this.$refs.categoryForm.resetFields()
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.categoryForm.file = this.needUrl
          this.$axios
            .post('api/single_item_add_body', this.categoryForm)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.$refs.categoryForm.resetFields()
                this.categoryIndrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .put('api/advicecate/edit', {
              id: this.category,
              category_name: this.editCategoryForm.categoryId,
              display: this.ifDisplay === false ? 1 : 0,
            })
            .then((res) => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio(row) {
      this.$axios
        .put('api/advicecate/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0,
        })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort(row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/advicecate/setsort', {
          id: row.id,
          sort: this.listSort[row.id],
        })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    handleCloseDis(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          if (this.$refs.distributeForm) {
            this.$refs.distributeForm.resetFields()
          }
          this.fileList = []
          this.needUrl = []
          this.change = false
          this.aboutExId = ''
          this.distributeForm.progress = 1
          this.FOptions = []
          done()
        })
        .catch((_) => { })
    },
    openExamineFeed(id) {
      this.aboutExId = id
      this.$axios
        .get('api/handover_examine/' + id + '/edit')
        .then(({ data }) => {
          if (data.code === 1) {
            this.FOptions = data.data
            let obj = data.data[0]
            this.distributeForm.progress = obj ? obj.progress : 1
          }
        })
        .catch()
      this.distributeDrawer = true
    },
  },
}
</script>
<style scoped>
.handover_examine {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

#forStyle>>>.demo-table-expand {
  font-size: 0;
}

#forStyle>>>.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

#forStyle>>>.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/miniProQiYeHuoConfig/QiYeHuo.vue